<template>
  <div>
    <p v-if="notification.statusId < 3">
      Please check the following information about proposed activities. If you need to make
      corrections, please return to the Activity Details page.
    </p>
    <hr class="border-dark" >
    <HarvestDetails />
    <hr class="border-dark">
    <RoadDetails />
    <hr class="border-dark">
    <WaterCrossingDetails />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HarvestDetails from '@/components/notification/summary/HarvestDetails.vue';
import RoadDetails from '@/components/notification/summary/RoadDetails.vue';
import WaterCrossingDetails from '@/components/notification/summary/WaterCrossingDetails.vue';

export default {
  name: 'ActivityDetails',
  components: {
    HarvestDetails,
    RoadDetails,
    WaterCrossingDetails,
  },
  computed: {
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
  },
  created() {
    if (this.$route.params.id) {
      this.$store.dispatch('ActivityDetails/fetch');
      this.$store.dispatch('ActivityDetails/fetchRequirements');
    }
  },
};
</script>
